import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "content", "icon"]
  static values = {
    isOpen: { type: Boolean, default: false }
  }

  connect() {
    if (this.isOpenValue) {
      this.toggle()
    }
  }

  toggle() {
    this.isOpenValue = !this.isOpenValue
    this.contentTarget.classList.toggle('hidden')
    this.iconTarget.classList.toggle('rotate-180')
  }
}
